import { PublicPageShell, PublicPageCta } from "./PublicPageShell";
import { cn } from "../cn";
import { useI18n } from "../../i18n";

/**
 * AboutPage — MACRO #26 · Increment 3 — THE GRID Product Manifesto.
 *
 * A dedicated PUBLIC route (`#about`). Honest, anti-fake copy only. All
 * user-facing copy is sourced from the i18n layer (English canonical).
 */
const NUMBERS = ["01", "02", "03", "04", "05", "06"];

export function AboutPage() {
  const { dict, t } = useI18n();
  return (
    <PublicPageShell
      testId="about-page"
      index="A · 01"
      eyebrow={t("about.eyebrow")}
      title={
        <>
          {dict.about.titleLine1}
          <br />
          <span
            className="bg-clip-text text-transparent"
            style={{ backgroundImage: "linear-gradient(90deg,#2DB6F0 0%,#74D4FF 55%,#118FD4 100%)" }}
          >
            {dict.about.titleHighlight}
          </span>
        </>
      }
      intro={t("about.intro")}
      footer={<PublicPageCta />}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {dict.about.principles.map((p, i) => {
          const n = NUMBERS[i];
          return (
            <article
              key={n}
              data-testid={`about-principle-${n}`}
              className={cn(
                "neon-glass p-6 flex flex-col gap-3",
                "transition-transform duration-med hover:-translate-y-0.5",
              )}
            >
              <div className="flex items-center gap-3">
                <span className="font-mono text-[11px] font-semibold tracking-[0.24em] text-neon-teal">
                  {n}
                </span>
                <span aria-hidden className="h-px flex-1 bg-border-divider" />
              </div>
              <h2 className="font-display text-[15px] font-semibold tracking-[0.02em] text-text-primary">
                {p.title}
              </h2>
              <p className="font-display text-[13px] leading-[1.6] text-text-secondary">
                {p.body}
              </p>
            </article>
          );
        })}
      </div>
    </PublicPageShell>
  );
}
